var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, after, before, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, isLong, number, prompt, submitUp, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content-fill invisible\"><div class=\"content-fit block-v-xl content text-center\">");
if ( before)
{
buf.push("<div class=\"block-v-md\"><h1 class=\"number-picker-title slide-down\">" + (null == (jade_interp = before) ? "" : jade_interp) + "</h1></div>");
}
buf.push("<div" + (jade.cls(['number-pickers','scale-up','block-v-md',isLong ? "pickers-sm" : ""], [null,null,null,true])) + ">");
if ( number.prefix)
{
buf.push("<div class=\"number-picker-prefix text-right text-xxl\">" + (null == (jade_interp = number.prefix) ? "" : jade_interp) + "</div>");
}
// iterate (new Array(number.digits))
;(function(){
  var $$obj = (new Array(number.digits));
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var el = $$obj[i];

buf.push("<div class=\"number-picker block-dk\"><div class=\"btn btn-solid btn-block text-sm number-picker-arr-up\"><span class=\"icon icon-chevron-up text-lg\"></span></div><div class=\"number-picker-nums\"><div class=\"number-picker-nums-scroller\">");
// iterate new Array(11)
;(function(){
  var $$obj = new Array(11);
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var el = $$obj[j];

buf.push("<div class=\"number-picker-num block-h-md\"><div class=\"text-fixed\">" + (jade.escape(null == (jade_interp = j % 10) ? "" : jade_interp)) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var el = $$obj[j];

buf.push("<div class=\"number-picker-num block-h-md\"><div class=\"text-fixed\">" + (jade.escape(null == (jade_interp = j % 10) ? "" : jade_interp)) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div></div><div class=\"btn btn-solid btn-block text-sm number-picker-arr-down\"><span class=\"icon icon-chevron-down text-lg\"></span></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var el = $$obj[i];

buf.push("<div class=\"number-picker block-dk\"><div class=\"btn btn-solid btn-block text-sm number-picker-arr-up\"><span class=\"icon icon-chevron-up text-lg\"></span></div><div class=\"number-picker-nums\"><div class=\"number-picker-nums-scroller\">");
// iterate new Array(11)
;(function(){
  var $$obj = new Array(11);
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var el = $$obj[j];

buf.push("<div class=\"number-picker-num block-h-md\"><div class=\"text-fixed\">" + (jade.escape(null == (jade_interp = j % 10) ? "" : jade_interp)) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var el = $$obj[j];

buf.push("<div class=\"number-picker-num block-h-md\"><div class=\"text-fixed\">" + (jade.escape(null == (jade_interp = j % 10) ? "" : jade_interp)) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div></div><div class=\"btn btn-solid btn-block text-sm number-picker-arr-down\"><span class=\"icon icon-chevron-down text-lg\"></span></div></div>");
    }

  }
}).call(this);

if ( number.suffix)
{
buf.push("<div class=\"number-picker-suffix text-left text-xxl\">" + (null == (jade_interp = number.suffix) ? "" : jade_interp) + "</div>");
}
buf.push("</div>");
if ( after)
{
buf.push("<div class=\"block-v-md\"><h1 class=\"number-picker-title slide-up\">" + (null == (jade_interp = after) ? "" : jade_interp) + "</h1></div>");
}
buf.push("</div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"after" in locals_for_with?locals_for_with.after:typeof after!=="undefined"?after:undefined,"before" in locals_for_with?locals_for_with.before:typeof before!=="undefined"?before:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isLong" in locals_for_with?locals_for_with.isLong:typeof isLong!=="undefined"?isLong:undefined,"number" in locals_for_with?locals_for_with.number:typeof number!=="undefined"?number:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}